import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import '@tiny-fox/storybook-renderer/fonts.css';
import '@tiny-fox/storybook-renderer/renderer.css';
import './index.css';
import App from './App';

// Use an extension so the SPA server cannot mistake the release marker for a
// client-side route and return index.html.
fetch('/version.txt')
  .then(res => {
    if (!res.ok) throw new Error('Version marker unavailable');
    return res.text();
  })
  .then(version => console.log(`🎨 Frontend v${version.trim()}`))
  .catch(() => console.log('🎨 Frontend (version unknown)'));

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={googleClientId}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);
